
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";

interface CommonDetailsProps {
  accessibilityFeatures: string;
  setAccessibilityFeatures: (value: string) => void;
  tags: string;
  setTags: (value: string) => void;
  isExistingPlace?: boolean;
}

export function CommonDetails({
  accessibilityFeatures,
  setAccessibilityFeatures,
  tags,
  setTags,
  isExistingPlace = false
}: CommonDetailsProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="accessibility">Accessibility Features</Label>
        <Input
          id="accessibility"
          value={accessibilityFeatures}
          onChange={(e) => setAccessibilityFeatures(e.target.value)}
          placeholder="Enter accessibility features separated by commas"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="tags">Tags</Label>
        <Input
          id="tags"
          value={tags}
          onChange={(e) => setTags(e.target.value)}
          placeholder="Enter tags separated by commas"
        />
      </div>
    </div>
  );
}
